var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{staticClass:"loader-style",attrs:{"size":70,"width":7,"color":"black","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }